(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
  const iframe = document.querySelector('iframe[src*="vimeo"]');
  if (iframe) iframe.src = iframe.src;
});
  } catch(e) { console.error(e); }
})();

})();
